import React from 'react';
import clsx from 'clsx';

function SegmentedControl({ options, value, onChange, name, label }) {
  return (
    <fieldset className="border-0 p-0 m-0">
      {label && (
        <legend className="text-body-sm font-semibold text-surface-700 mb-2">
          {label}
        </legend>
      )}
      <div
        className="inline-flex bg-surface-100 rounded-xl p-1 gap-0.5"
        role="radiogroup"
        aria-label={label || name}
      >
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isActive}
              name={name}
              onClick={() => onChange(option.value)}
              className={clsx(
                'flex items-center gap-2 px-4 py-2 text-body-sm font-medium rounded-lg transition-all duration-200 outline-none',
                'focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:ring-offset-1',
                isActive
                  ? 'bg-white text-surface-900 shadow-soft-sm'
                  : 'text-surface-500 hover:text-surface-700'
              )}
            >
              {option.icon && (
                <span className="flex-shrink-0" aria-hidden="true">
                  {option.icon}
                </span>
              )}
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}

export default SegmentedControl;
